"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_html_1 = __importDefault(require("./widget.html"));
require("./widget.less");
(function (module) {
    'use strict';
    var SELECTION_ID_ATTR = 'selectionId';
    var TABLE_DENSITY_PREFIX = 'TABLE_DENSITY_STYLE_';
    /*
     * Responsible for converting the widget layout coming from flowing-pages to css,
     * and converting the css that is being modified in the freeformItem back to the layout css
     * Draws a widget, has a view that updates flowing-pages when dimensions change,
     * watches for changes on it's layout to know when to update the view
     */
    module.directive('prWidget', [
        '$filter',
        '$timeout',
        '$document',
        '$routeParams',
        'prAutoHeightHelper',
        'prEventService',
        'prFlowingPages',
        'prPageLayoutService',
        'prViewOptions',
        'prWidgetChunkerFactory',
        'undoRedoStack',
        'pr.widgetManager',
        'pr.globalOptionsService',
        'prConditionalDisplay',
        'pr.widgetStylesService',
        function ($filter, $timeout, $document, $routeParams, autoHeight, eventService, flowingPages, pageLayout, viewOptions, chunker, undoService, widgetManager, globalOptions, conditionalDisplay, widgetStylesService) {
            return {
                restrict: 'E',
                templateUrl: widget_html_1.default,
                // we will rely on a widget existing from ng-repeat
                scope: false,
                require: '^^prBody',
                link: function ($scope, $element, $attrs, $bodyCtrl) {
                    init();
                    $scope.$on('$destroy', destroy);
                    var widgetErrorMsg = '';
                    // trying to think of a better way to do this
                    angular.extend($scope, {
                        getSelectionId: getSelectionId,
                        isSelected: function () {
                            return $scope.widget._id === $bodyCtrl.activeWidgetId;
                        },
                        conditionalDisplay: function () {
                            var isPublicView = $routeParams.publicHash || $routeParams.preview;
                            return !isPublicView && conditionalDisplay.isDisplayLogicEnabled($scope.widget._id);
                        },
                        getHiddenIndicatorClass: function () {
                            var iconClass = 'icon icon-eye-hidden';
                            if (conditionalDisplay.isHiddenInPublic($scope.widget._id)) {
                                iconClass += ' hide-in-public';
                            }
                            return iconClass;
                        },
                        getConditionalDisplayInfo: function () {
                            var translate = $filter('translate');
                            var widgetId = $scope.widget._id;
                            return conditionalDisplay.isHiddenInPublic(widgetId) ? translate('PR.DISPLAY_LOGIC_HIDE') : translate('PR.DISPLAY_LOGIC_SHOW');
                        },
                        setWidgetError: function (msg) {
                            widgetErrorMsg = msg;
                        },
                        getWidgetError: function () {
                            return widgetErrorMsg;
                        }
                    });
                    function init() {
                        // we add the id so we can retrieve it from widget-transformer.js
                        var selectionId = getSelectionId();
                        $element.attr(SELECTION_ID_ATTR, selectionId);
                        // initially set the padding, then listen for changes and update
                        $timeout(updatePaddingStyle);
                        eventService.stream($scope.widget._id).on('widgetPaddingChanged', updatePaddingStyle);
                        eventService.stream($scope.widget._id).on('widgetTableBodyDensityChanged', updateTableBodyDensity);
                        eventService.stream($scope.widget._id).on('widgetStyleChanged', updateFontStyle);
                        eventService.stream(selectionId).on('startTransform', stopWatchingLayout);
                        eventService.stream(selectionId).on('stopTransform', startWatchingLayout);
                        startWatchingLayout();
                    }
                    function destroy() {
                        if ($scope) {
                            eventService.stream($scope.widget._id).off('widgetPaddingChanged', updatePaddingStyle);
                            eventService.stream($scope.widget._id).off('widgetTableBodyDensityChanged', updateTableBodyDensity);
                            eventService.stream($scope.widget._id).off('widgetStyleChanged', updateFontStyle);
                            var selectionId = getSelectionId();
                            eventService.stream(selectionId).off('startTransform', stopWatchingLayout);
                            eventService.stream(selectionId).off('stopTransform', startWatchingLayout);
                            selectedWatcher();
                            stopWatchingLayout();
                            $scope = null;
                            $element = null;
                        }
                    }
                    function updatePaddingStyle() {
                        if (!($scope && $scope.widget)) {
                            return;
                        }
                        var widget = flowingPages.getWidget($scope.widget._id);
                        $element.find('.widget-padding').css('padding', widget.layout.padding || globalOptions.getWidgetPadding());
                        updateChunkedWidget(widget);
                    }
                    function updateChunkedWidget(widget) {
                        var status = widgetManager.getWidgetStatus($scope.widget._id);
                        // if widget is not chunked yet we don't need to reflow it
                        if ($scope.widget.layout.chunkIndex === 0 && _.contains(['COMPLETED', 'DATA_LOADED', 'RESIZED'], status)) {
                            chunker.updateChunks(widget);
                            flowingPages.reflow();
                        }
                    }
                    function updateTableBodyDensity() {
                        if (!($scope && $scope.widget)) {
                            return;
                        }
                        var widget = flowingPages.getWidget($scope.widget._id);
                        if (widget.layout.tableBodyDensity) {
                            // optimization
                            return;
                        }
                        var nodeName = TABLE_DENSITY_PREFIX + $scope.widget._id;
                        widgetStylesService.applyTableBodyDensity($scope.widget._id, nodeName, (widget.layout.style.tableBodyDensity || globalOptions.getTableBodyDensity()));
                        updateChunkedWidget(widget);
                    }
                    function updateFontStyle() {
                        if (!($scope && $scope.widget)) {
                            return;
                        }
                        var widget = flowingPages.getWidget($scope.widget._id);
                        updateChunkedWidget(widget);
                    }
                    var selectedWatcher = $scope.$watch('isSelected()', function (val) {
                        /*
                         * Logic for handling widget switch: only attached when widget is selected
                         */
                        if (val) {
                            // Using tempScope because sometimes it end up being null
                            // inside of the widgetSwitch event callback
                            // TODO: figure out why this happens
                            var tempScope_1 = $scope;
                            eventService.stream($scope.widget._id).on('hideWidget', function () {
                                // Hide the widget
                                tempScope_1.reRenderWidget = true;
                                // Wait for flowingPages to update the type
                                var typeChangeWatcher = tempScope_1.$watch('widget._type', function () {
                                    $timeout(function () {
                                        // Show the widget
                                        tempScope_1.reRenderWidget = false;
                                        // Update FreeformItem (resize, border)
                                        setStyles();
                                        $timeout(function () {
                                            updatePaddingStyle();
                                        });
                                    });
                                    // Remove type change watcher
                                    typeChangeWatcher();
                                });
                            });
                        }
                        else {
                            // turn off event when widget is deselected
                            eventService.stream($scope.widget._id).off('hideWidget');
                        }
                    });
                    var layoutWatcher;
                    function stopWatchingLayout() {
                        if (layoutWatcher) {
                            layoutWatcher();
                            layoutWatcher = null;
                        }
                    }
                    function startWatchingLayout() {
                        // using $watchCollection is the bomb! We get about 50% speed increase over watching it ourselves
                        layoutWatcher = $scope.$watchCollection('widget.layout', function () {
                            setStyles();
                        });
                    }
                    function setStyles() {
                        $element.css(pageLayout.convertLayoutToStyle($scope.widget.layout));
                        var widget = flowingPages.getWidget($scope.widget._id);
                        widgetManager.onSetLayoutStyles(widget);
                    }
                    function getSelectionId() {
                        return $scope.widget.layout.id;
                    }
                }
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
